import * as React from 'react';
import { Datagrid, ImageField, ListProps, TextField } from 'react-admin';
import './RecipeCategoryDatagrid.scss';
import { TranslateField } from '../components/TranslateField';

export const RecipeCategoryDatagrid = (props: ListProps): React.ReactElement => {
	return (
		<Datagrid rowClick="edit" className="recipe-categories-table" optimized
		          hasBulkActions={true}
		          rowStyle={(row: any) => ({ borderRightColor: row._readAt ? '#49d18c' : '#bbbbbb' })}>
			<TextField source="id" label="#"/>
			<TextField source="name" label="NAME"/>
			{/*<TextField source="description" label="DESCRIPTION"/>*/}
			<ImageField source="imageUrl" label="IMAGE"/>
			<TranslateField source="language" label="LANGUAGE"/>
		</Datagrid>
	);
};
